import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZaiPaymentsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "zai-payments-icon-gradient",
		x1: 250,
		y1: 96.7,
		x2: 250,
		y2: 407.3,
		gradientTransform: "translate(0 502) scale(1 -1)",
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: 0,
			stopColor: "#6738bd"
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#ee3932"
		})]
	}) }), /* @__PURE__ */ _jsx("polygon", {
		fill: "url(#zai-payments-icon-gradient)",
		points: "293.9 138.7 293.9 200.8 343.2 250 272 321.2 272 116.7 250 94.7 94.7 250 206.1 361.3 206.1 299.2 156.8 250 228 178.8 228 383.3 250 405.3 405.3 250 293.9 138.7"
	})]
});
export { SvgZaiPaymentsIcon as ReactComponent };
